module.exports = __webpack_public_path__ + "img/bg3.41ebc96f.png";